import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

interface DeleteConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  employeeCount: number
  onConfirm: (changeGroup: boolean | null) => void
}

export function DeleteConfirmDialog({ open, onOpenChange, employeeCount, onConfirm }: DeleteConfirmDialogProps) {
  const handleCancel = () => {
    onOpenChange(false)
    onConfirm(null)
  }

  const handleChangeGroup = () => {
    onOpenChange(false)
    onConfirm(true)
  }

  const handleNoChange = () => {
    onOpenChange(false)
    onConfirm(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>임직원 삭제 확인</DialogTitle>
          <DialogDescription>
            선택된 {employeeCount}명의 임직원을 삭제합니다.
            <br />
            삭제하는 임직원의 회원 등급을 변경하시겠습니까?
          </DialogDescription>
        </DialogHeader>
        
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={handleCancel}
          >
            취소
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={handleNoChange}
          >
            변경 안함
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={handleChangeGroup}
          >
            변경함
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}